import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchWorkspaceAttention } from '@/api/attention/attentionApi';
import type { WorkspaceAttention } from '@/api/attention/attentionApi.types';
import { WORKSPACE_ATTENTION_QUERY_KEY } from '@/constants/queryKeys';

export function useWorkspaceAttentionQuery(
  clientId: string | null
): UseQueryResult<WorkspaceAttention, Error> {
  return useQuery({
    queryKey: [...WORKSPACE_ATTENTION_QUERY_KEY, clientId === null ? 'all' : clientId],
    queryFn: function load() {
      return fetchWorkspaceAttention(clientId);
    },
  });
}
